import type { ContentSection as ContentSectionType } from "@/lib/content-parser";
import { renderTextWithLinks } from "@/lib/render-markdown-links";

interface ContentSectionProps {
  section: ContentSectionType;
  colour?: string;
  isSelected?: boolean;
}

export function ContentSection({ section, colour, isSelected }: ContentSectionProps) {
  return (
    <div>
      <h3 className="text-xl font-semibold text-foreground">
        <span
          className="rounded-md border border-transparent px-2 py-0.5 transition-colors duration-700 ease-in-out"
          style={isSelected && colour ? {
            backgroundColor: `oklch(from ${colour} l c h / 0.15)`,
            borderColor: `oklch(from ${colour} l c h / 0.4)`,
          } : undefined}
        >
          {section.heading}
        </span>
      </h3>
      <p className="mt-2 text-muted-foreground">{renderTextWithLinks(section.body)}</p>
    </div>
  );
}
